
<template>
  <div>
    <div class="page-hd">
      <el-menu @select="handleMenuChange" :default-active="active" class="el-menu-order" background-color="#ebebeb" text-color="#303133" active-text-color="#CFA972" mode="horizontal">
        <el-menu-item :route="item.path" :index="item.type" v-for="(item,index) in tabs" :key="index">{{item.name}}</el-menu-item>
      </el-menu>
    </div>
    <div class="page-bd">
      <div class="cart-list">
        <el-card shadow="hover" class="cart-item" v-for="(item,index) in list" v-bind:key="index">
          <div slot="header" class="cart-item-head">
            <span>
              <el-tag type="success">{{item.OrderTypeName}}</el-tag><span class="ordernum">订单编号：<span>{{item.OrderNo}}</span></span>
            </span>
            <span class="time"></span>
            <span class="status"> <span>{{orderStateText(item.OrderState)}}</span></span>
          </div>
          <div class="cart-item-body">
            <div class="goods-item">
              <div class="goods-main">
                <div class="goods-img">
                  <img :src="item.Photo" alt="">
                </div>
                <div class="goods-msg">
                  <div class="name">{{item.ProductName}}</div>
                  <div class="extra">
                    <p class="info">作品尺寸：{{item.ProductSize}}</p>
                    <p class="info">创作时间： {{item.CreateYear}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="amount">
              <p class="">成交价：<span class="span">￥{{item.RealPrice}}</span></p>
            </div>
            <div class="operate">
              <div v-if="item.OrderState ==='1'">
                <el-button type="primary" @click="gopay(item.OrderId,item.OrderNo)" plain>立即付款</el-button>
              </div>
              <div v-if="item.OrderState ==='2'">
                <el-button type="primary" @click="reminder(item.OrderId)" :disabled="item.IsReminder=='1'?true:false" plain>{{item.IsReminder=='1'?'已催促发货':'提醒发货'}}</el-button>
              </div>
              <div v-if="item.OrderState ==='3' ||item.OrderState ==='4' ">
                <el-button type="primary" @click="logistics(item.OrderId)" plain>查看物流</el-button>
              </div>
              <div v-if="item.OrderState ==='3'">
                <el-button type="primary" @click="confirmReceipt(item.OrderId)" plain>确认收货</el-button>
              </div>
            </div>
          </div>
        </el-card>
        <el-link class="btn-more" :underline="false" disabled v-if="isend">没有更多了</el-link>
        <el-link class="btn-more" :underline="false" @click="orderlistByState" v-if="!isend">加载更多</el-link>
      </div>

    </div>
  </div>
</template>
<script>
import {
  Usercenter
} from "../../model/usercenter.js";
let usercenter = new Usercenter();
export default {
  name: 'order',
  data() {
    return {
      tabs: [
        { name: '待付款', type: "1" },
        { name: '待发货', type: "2" },
        { name: '待收货', type: "3" },
        { name: '已收货', type: "4" },
      ],
      active: "1",
      pageIndex: 1,
      pageSize: 10,
      list: [],
      isend: false
    }
  },
  components: {

  },
  methods: {
    orderlistByState() {
      let _this = this;
      usercenter.listOrder({
        BuyerId: _this.user ? _this.user.id : "",
        OrderState: _this.active,
        PageIndex: _this.pageIndex,
        PageSize: _this.pageSize
      }).then(function (res) {
        let plist = res;
        if (plist) {
          if (plist.length < _this.pageSize || plist.length == 0) {
            _this.isend = true;
          }
          _this.list = plist.length > 0 ? _this.list.concat(plist) : _this.list;
        } else {
          _this.isend = true;
        }


      })
    },
    orderStateText: function (state) {
      switch (state) {
        case '1':
          return '等待付款'
        case '2':
          return '等待发货'
        case '3':
          return '卖家已发货'
        case '4':
          return '已完成'
      }
    },
    handleMenuChange(index) {
      this.active = index;
      this.list = [];
      this.pageIndex = 1;
      this.orderlistByState()
    },
    //催促发货
    reminder(id) {
      let _this = this;
      usercenter.reminder({
        id: id
      }).then(function () {
        _this.$message({
          message: '催促发货成功',
          type: 'success'
        });
      })
    },
    //确认收货弹窗
    confirmReceipt(id) {
      let _this = this;
      _this.$confirm('您确认已收到货物了吗？', '重要提示', {
        confirmButtonText: '已收到',
        cancelButtonText: '手滑了',
        type: 'warning'
      }).then(() => {
        _this.receipt(id)
      }).catch(() => { });
    },
    //确认收货
    receipt(id) {
      let _this = this;
      usercenter.confirmReceipt({
        OrderId: id,
        CustomerId: _this.user ? _this.user.id : ""
      }).then(function () {
        window.location.reload();
      })
    },
    //查看物流
    logistics(id) {
      let _this = this;
      _this.$router.push({ path: '/usercenter/wuliu', query: { OrderId: id } })
    },
    //去付款
    gopay(id, orderno) {
      let _this = this;
      _this.$router.push({ path: '/checkout', query: { orderIds: id, orderNos: orderno } })
    },
  },
  created() {
    this.orderlistByState()
  }
}
</script>
<style lang="scss">
@import "../../assets/card.scss";
.page-hd {
  .el-menu-order {
    .el-menu-item {
      height: 40px;
      line-height: 40px;
      width: 25%;
      text-align: center;
    }
  }
}
.cart-list {
  padding: 0 10px 20px;
}
</style>